/**
 * ed-lazy-scripts.js
 * Defers non-critical third-party scripts until after first user interaction
 * or when the browser is idle (requestIdleCallback / setTimeout fallback).
 *
 * Only included for non-CH storefronts (the script tag in theme.liquid is
 * wrapped in {% unless localization.country.iso_code == 'CH' %}).
 */
(function () {
  let loaded = false;

  const scripts = [
    // Varify.io A/B testing – window.varify.iid is set inline before this loads
    { src: 'https://app.varify.io/varify.js', async: 'true' },
  ];

  function loadScript(src, attrs) {
    const s = document.createElement('script');
    s.src = src;
    Object.entries(attrs || {}).forEach(function (entry) {
      s.setAttribute(entry[0], entry[1]);
    });
    document.head.appendChild(s);
  }

  function loadAll() {
    if (loaded) return;
    loaded = true;
    scripts.forEach(function (item) {
      const src = item.src;
      const attrs = Object.assign({}, item);
      delete attrs.src;
      loadScript(src, attrs);
    });
  }

  ['scroll', 'click', 'keydown', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, loadAll, { once: true, passive: true });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadAll);
  } else {
    setTimeout(loadAll, 3000);
  }
})();
